<template>
  <div class="concatus">

    <!-- 顶部提示banner -->
    <div class="page-heading" style="background-image: url('static/menhu/images/cc1.jpg')">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="textsd">为居者打造梦想之门</h1>
            <span class="textsd">Create a dream of dreams for the residents</span>
          </div>
        </div>
      </div>
    </div>

    <div class="lxdiv">
      <h3 style="text-align: center">联系我们</h3>
      <div class="lxmain">
        <div class="ml">
          <div class="ml_item">
            <h3>{{ common_platform_data.compName }}</h3>
          </div>
          <div class="ml_item">
            <a :href="'https://uri.amap.com/navigation?to='+common_platform_data.compAddressLat+','+common_platform_data.compAddressLong+','+common_platform_data.compAddress+'&mode=car&policy=1&src=mypage&callnative=0'"><i class="el-icon-location-information"></i>地址：{{ common_platform_data.compAddress }}</a>
<!--            <p @click="openNavigation(common_platform_data.compAddressLat,common_platform_data.compAddressLong)"></p>-->
          </div>
          <div class="ml_item">
            <p><i class="el-icon-phone-outline"></i>电话：<a rel="nofollow" :href="'tel:'+common_platform_data.compTell">{{ common_platform_data.compTell }}</a></p>
          </div>
          <div class="ml_item">
            <p><a href="tel:4001811810"><i class="fa fa-phone"></i> 售后电话：400-181-1810</a></p>
          </div>
          <div class="ml_item">
            <p><i class="el-icon-message"></i>邮箱：{{ common_platform_data.compEmail }}</p>
          </div>
          <div class="ml_item">
            <p><i class="el-icon-chat-dot-round"></i>添加官方微信联系方式，及时获取最新动态</p>
            <img :src="common_platform_data.compSWchatRcode" />
          </div>
          <div class="ml_item">
            <p ><i class="el-icon-trophy"></i>加盟以及咨询热线：<a rel="nofollow" :href="'tel:'+common_platform_data.compJoinTell">{{ common_platform_data.compJoinTell }}</a></p>
          </div>
        </div>
        <!-- 右侧地图 -->
        <div class="mr">
          <baidumap :lat="common_platform_data.compAddressLat" :lng="common_platform_data.compAddressLong" :mtitle="common_platform_data.compName" :mdesc="common_platform_data.compAddress" :mtell="common_platform_data.compTell"/>
        </div>
      </div>
    </div>

    <!-- 加盟咨询 -->
    <div class="jmxxdiv" style="margin-top: 15px;padding: 0px 10% 0px 10%">
      <h3 style="text-align: center">咨询留言</h3>
      <Concat concatName="联系我们页面"/>
    </div>

  </div>
</template>

<script>
import baidumap from "@/components/views/baidumap.vue";
import  Concat from '@/components/common_concat';
export default {
  name: 'concatus',
  components:{baidumap,Concat},
  data() {
    return {
      common_platform_data:{
        "id": null,
        "createBy": null,
        "createTime": null,
        "updateBy": null,
        "updateTime": null,
        "sysOrgCode": null,
        "platformName": null,
        "platformAdvertisement": null,
        "compName": null,
        "compEmail": null,
        "compTell": null,
        "compAddress": null,
        "compAddressLat": null,
        "compAddressLong": null,
        "compJoinTell": null,
        "compSQq": null,
        "compSWchat": null,
        "compWgzhRcode": null,
        "compSWchatRcode": null,
        "icpName": null,
        "icpHost": null,
        "icpYear": null,
        "icpCode": null
      }
    }
  },
  created() {
    this.getCompInfoData();
  },
  methods:{
    // 查询公司以及平台信息
    getCompInfoData(){
      let _this = this;
      this.$axios.get('/fantis/compdata/ftComp/queryById?id=101')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;
            _this.common_platform_data = res.data.result;
            if(_this.common_platform_data.compWgzhRcode!=null && _this.common_platform_data.compWgzhRcode!=""){
              _this.common_platform_data.compWgzhRcode =
                _this.$fileDPath + _this.common_platform_data.compWgzhRcode;
            }
            if(_this.common_platform_data.compSWchatRcode!=null && _this.common_platform_data.compSWchatRcode!=""){
              _this.common_platform_data.compSWchatRcode =
                _this.$fileDPath + _this.common_platform_data.compSWchatRcode;
            }
          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.concatus{
  background-color: #f4f4f4;
}
.textsd{
  text-shadow: 2px 2px 50px gray;
}
.lxdiv{
  width: 100%;
  box-sizing: border-box;
  padding: 2% 5%;
}
.lxmain{
  background-color: #FFF;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  padding: 20px;
}
.mr{
  width: 50%;
}
.ml{
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}
.ml_item p{
  line-height: 2;
  font-size: 18px;
  color: #6B6666;
}


@media only screen and (max-width: 800px) {
 .lxmain{
   flex-direction: column;
 }
  .mr{
    width: 100%;
  }
  .baidumap{
    height: 400px !important;
  }
  .ml{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/concatsus.vue